import { render, staticRenderFns } from "./Seo.vue?vue&type=template&id=8c01b27c&scoped=true"
import script from "./Seo.vue?vue&type=script&lang=js"
export * from "./Seo.vue?vue&type=script&lang=js"
import style0 from "./Seo.vue?vue&type=style&index=0&id=8c01b27c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c01b27c",
  null
  
)

export default component.exports